<template>
  <el-tabs v-model="activeId" @tab-click="handleClick"  class="companyList">
    <el-tab-pane :label="item.name" :name="item.id" v-for="(item,index) in data" :key="index"/>
  </el-tabs>
</template>

<script>
import { getAvailableCompanyList } from "@/api/product/base"

export default {
  data(){
    return {
      data:[],
      activeId:0
    }
  },
  created(){
    this.getData()
  },
  methods:{
    async getData(){
      const res = await getAvailableCompanyList()
      this.data = res.data
      this.data.unshift({
        id:'1',
        name:"国家广电人才网超管平台"
      })
      this.activeId = this.data[0].id
      this.$emit('selectId',this.data[0].id)
    },
    handleClick(value){
      this.$emit('selectId',this.activeId)
    }
  }
}
</script>

<style lang="scss" scoped>
.companyList{
  margin-bottom: 15px;
  ::v-deep .el-tabs__nav-prev {
    height: 42px;
    bottom: 0;
  }
  ::v-deep .el-tabs__nav-next {
    height: 42px;
    bottom: 0;
  }
}
</style>
